import { getPanel } from './ui-panel-registry.js';

/**
 * Sets up a base panel controller by panel name (e.g. 'profiles', 'foods')
 * Assumes panel DOM ID matches controller registry (e.g. 'edit-profile-sheet')
 */
export function createPanelController(key, options = {}) {
  return {
    open() {
      // const panel = panels[key]; // ❗ resolve fresh
      const panel = getPanel(key);
      if (!panel) {
        console.warn(`[PanelController] Cannot open: '${key}' not found.`);
        return;
      }
      console.log('[PanelController] Opening panel:', key, panel);
      console.log('[PanelController] Panel exists:', !!panel);      

      panel.classList.remove('hidden');
      panel.offsetHeight; // Force reflow to reset transition
      panel.classList.add('visible');

      options.onOpen?.();
    },

    close() {
      // const panel = panels[key]; // ❗ resolve fresh
      // if (!panel) {
      //   console.warn(`[PanelController] Cannot close: '${key}' not found.`);
      //   return;
      // }

      const panel = getPanel(key);
      if (!panel) return;

      panel.classList.remove('visible');
      panel.classList.add('exiting');
      
      setTimeout(() => {
        panel.classList.add('hidden');
        panel.classList.remove('exiting');
      }, 400);

      options.onClose?.();
    },

    onSubmitSuccess: options.onSubmitSuccess || null
  };
}
